/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SendSurveyRequest } from '../../models/send-survey-request';
import { SendSurveyResponse } from '../../models/send-survey-response';

export interface SendSurvey$Plain$Params {
  caseId: string;
  
    /**
     * Lexicon.Surveys.Data.Models.SendSurveyRequest with query parameters
     */
    body?: SendSurveyRequest
}

export function sendSurvey$Plain(http: HttpClient, rootUrl: string, params: SendSurvey$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SendSurveyResponse>> {
  const rb = new RequestBuilder(rootUrl, sendSurvey$Plain.PATH, 'post');
  if (params) {
    rb.path('caseId', params.caseId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SendSurveyResponse>;
    })
  );
}

sendSurvey$Plain.PATH = '/api/Case/{caseId}/SendSurvey';
